import { useContext, useEffect } from 'react';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';
import { Card, CardContent, CardHeader, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, Typography, Grid, Divider, colors } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { CustomerRequestContext } from '../../CustomerRequestContext';
import { decimalNumberField } from '../../../../../helpers/Utils';
import { TabsContext } from '../TabsContext';
import { FieldError, Select } from '../../../../common';
import { SapTableNames } from '../../../../../helpers';

const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    divider: {
        backgroundColor: colors.grey[300],
        margin: '40px 0px 20px'
    }
}));

export const CreditManagementForm = (props) => {
    const classes = useStyles();

    const {
        values,
        setFieldValue
    } = useContext(TabsContext);

    const {
        state,
        getTableOptions,
        getTableOptionsWithCode,
        getSegmentsOptions
    } = useContext(CustomerRequestContext);

    const { errors } = state;

    const segmentsOptions = getSegmentsOptions();

    useEffect(() => {
        if (
            state.infoTypes &&
            state.infoTypes.length > 0 &&
            values.creditManagement.creditTypes.some(x => x.infoTypeId === "")
        ){
            const creditManagement = { ...values.creditManagement };

            creditManagement.creditTypes.forEach((x, index: number) => {
                x.infoTypeId = state.infoTypes[index].tableValueId;
                x.currencyId = values.riskEvaluation.creditLimitCurrencyId;
            });

            setFieldValue("creditManagement", creditManagement);
        }
    },[state.infoTypes]);

    return (
        <Card>
            <CardHeader title="Credit Management"/>
            <CardContent>
                <Grid item xl={12} md={12} xs={12}>
                    <Select
                        name="creditManagement.segmentId"
                        label="Segment *"
                        disabled={props.disabled}
                        options={segmentsOptions}
                    />
                    <FieldError name="creditManagement.segmentId" errors={errors} />
                </Grid>
                
                <Divider className={classes.divider} />

                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Credit type</TableCell>
                                <TableCell>Import</TableCell>
                                <TableCell>Currency</TableCell>
                                <TableCell>End of validity</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                values.creditManagement?.creditTypes.map((_, index) =>
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Select
                                                disabled
                                                style={{width: "418px"}}
                                                name={`creditManagement.creditTypes[${index}].infoTypeId`}
                                                options={getTableOptions(SapTableNames.InfoTypes, values.dbType)}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <div style={{width: "200px"}}>
                                                <Field
                                                    className={classes.field}
                                                    variant="outlined"
                                                    name={`creditManagement.creditTypes[${index}].import`}
                                                    disabled={props.disabled}
                                                    component={decimalNumberField}
                                                />
                                            </div>
                                        </TableCell>
                                        <TableCell>
                                            <Select
                                                disabled
                                                style={{width: "256px"}}
                                                name={`creditManagement.creditTypes[${index}].currencyId`}
                                                options={getTableOptionsWithCode(SapTableNames.Currencies, values.dbType)}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Field
                                                style={{width: "150px"}}
                                                className={classes.field}
                                                variant="outlined"
                                                type="date"
                                                name={`creditManagement.creditTypes[${index}].endOfValidity`}
                                                disabled={props.disabled}
                                                component={TextField}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <div style={{height: '20px', position: 'relative'}}>
                    <div style={{position: 'absolute', whiteSpace: 'nowrap'}}>
                        <FieldError
                            name="creditManagement.CreditTypes"
                            errors={errors}
                        />
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}